import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from "react";
import { BpayBillerHistoryDocument, useBpayBillerHistoryQuery, useDeleteBpayPartyBillerMutation, } from "generated/generated-models";
import { StringIsEqual } from "core/util/stringExtensions";
import { Loading } from "app/lib/components/Loading";
import { CError } from "app/common/CError";
import { useScreenSize } from "app/lib/useScreenSize";
import { Alert, Box, Button, Dialog, DialogContent, DialogContentText, DialogTitle, IconButton, List, ListItem, ListItemText, Paper, Stack, Typography, styled, useMediaQuery, } from "@mui/material";
import AddBpayBiller from "./AddBpayBiller";
import { DataGridPro, GridLogicOperator, } from "@mui/x-data-grid-pro";
import DeleteIcon from "@mui/icons-material/Delete";
import ClearIcon from "@mui/icons-material/Clear";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import { LoadingButton } from "@mui/lab";
import BpayText from "app/components/BpayText";
import NoRowsOverlay from "app/components/NoRowsOverlay";
const billerDisplayName = (biller) => {
    return `${biller.description === "" ? biller.name : biller.description} (${StringIsEqual(biller.description, biller.name) ? "" : biller.name.trim()})`;
};
const BillerHistoryRow = (props) => {
    return (_jsx(IconButton, { "aria-label": "delete", id: "deleteButton", children: _jsx(DeleteIcon, { onClick: () => props.deleteBiller(props.biller) }) }));
};
const ManageBpayBillerHistoryView = ({ billerHistory, deleteBiller, }) => {
    const [open, setOpen] = React.useState(false);
    const screenSize = useScreenSize();
    const fullScreen = useMediaQuery("(max-width: 768px)");
    const sortedBillers = billerHistory.sort((a, b) => a.description.toUpperCase() > b.description.toUpperCase() ? 1 : -1);
    const rows = sortedBillers;
    const columns = [
        {
            field: "name",
            headerName: "Biller Name",
            minWidth: 300,
            flex: 3,
            renderCell: (params) => billerDisplayName(params.row),
        },
        { field: "code", headerName: "Biller Code", minWidth: 150, flex: 2 },
        {
            field: "customerReferenceNumber",
            headerName: "Customer Ref",
            minWidth: 150,
            flex: 2,
        },
        {
            field: " ",
            headerName: "",
            minWidth: 20,
            flex: 1,
            align: "center",
            renderCell: (params) => (_jsx(BillerHistoryRow, { biller: params.row, deleteBiller: deleteBiller }, params.row.code)),
        },
    ];
    const Item = styled(Paper)(({ theme }) => ({
        backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
        ...theme.typography.body2,
        padding: theme.spacing(1),
        textAlign: "center",
        color: theme.palette.text.secondary,
    }));
    const handleAddBillerClick = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };
    return (_jsxs("div", { className: "biller-container", style: { height: 650, width: "100%" }, children: [_jsxs(Box, { className: "tab-header", sx: { mb: 2 }, children: [_jsxs(Typography, { variant: "h6", component: "h6", sx: { mx: 1, my: 0 }, children: [_jsx(BpayText, {}), " Billers"] }), _jsx(Button, { startIcon: _jsx(GroupAddIcon, {}), onClick: handleAddBillerClick, id: "addBillerButton", children: "Add Biller" })] }), screenSize === "desktop" ? (_jsx(DataGridPro, { className: "payees-grid", columns: columns, rows: rows, getRowId: (r) => r.id, pageSizeOptions: [10, 25, 50], pagination: true, initialState: {
                    pagination: {
                        paginationModel: { pageSize: 10 },
                    },
                }, slots: {
                    noRowsOverlay: () => (_jsxs(NoRowsOverlay, { children: ["You have no saved ", _jsx(BpayText, {}), " billers."] })),
                }, disableColumnSelector: true, slotProps: {
                    filterPanel: {
                        logicOperators: [GridLogicOperator.And],
                        columnsSort: "asc",
                        filterFormProps: {
                            logicOperatorInputProps: {
                                variant: "outlined",
                                size: "small",
                            },
                            columnInputProps: {
                                variant: "outlined",
                                size: "small",
                                sx: { mt: "auto" },
                            },
                            operatorInputProps: {
                                variant: "outlined",
                                size: "small",
                                sx: { mt: "auto" },
                            },
                            deleteIconProps: {
                                sx: {
                                    "& .MuiSvgIcon-root": {
                                        color: "#d32f2f",
                                    },
                                },
                            },
                        },
                        sx: {
                            "& .MuiDataGrid-filterForm": { p: 2 },
                            "& .MuiDataGrid-filterForm:nth-child(even)": {
                                backgroundColor: (theme) => theme.palette.mode === "dark"
                                    ? "#444"
                                    : "#f5f5f5",
                            },
                            "& .MuiDataGrid-filterFormLinkOperatorInput": {
                                mr: 2,
                            },
                            "& .MuiDataGrid-filterFormColumnInput": {
                                mr: 2,
                                width: 150,
                            },
                            "& .MuiDataGrid-filterFormOperatorInput": {
                                mr: 2,
                            },
                            "& .MuiDataGrid-filterFormValueInput": {
                                width: 200,
                            },
                        },
                    },
                } })) : (_jsx(Stack, { spacing: 2, children: sortedBillers.map((biller) => {
                    return (_jsx(Item, { sx: { pb: 1.5 }, children: _jsxs(List, { className: "payees-list-mobile", children: [_jsx(ListItem, { disablePadding: true, className: "delete-item", children: _jsx(ListItemText, { primary: _jsx(Typography, { children: _jsx(IconButton, { "aria-label": "delete", id: "deletePayeeButton", children: _jsx(ClearIcon, { onClick: () => deleteBiller(biller) }) }) }) }) }), _jsx(ListItem, { disablePadding: true, sx: { px: 3 }, children: _jsx(ListItemText, { primary: _jsx(Typography, { children: _jsx("span", { className: "subtitle", children: biller.description }) }) }) }), _jsx(ListItem, { disablePadding: true, sx: { px: 3 }, children: _jsx(ListItemText, { primary: _jsx(Typography, { children: biller.name }) }) }), _jsx(ListItem, { disablePadding: true, sx: { px: 3 }, children: _jsx(ListItemText, { primary: _jsxs(Typography, { children: [_jsxs("span", { className: "subtitle", children: ["Biller Code:", " "] }), " ", biller.code] }) }) }), _jsx(ListItem, { disablePadding: true, sx: { px: 3 }, children: _jsx(ListItemText, { primary: _jsxs(Typography, { children: [_jsxs("span", { className: "subtitle", children: ["Customer Ref:", " "] }), " ", biller.customerReferenceNumber] }) }) })] }) }, biller.id));
                }) })), _jsx(Dialog, { fullScreen: fullScreen, className: "add-payee", open: open, onClose: handleClose, fullWidth: true, children: _jsx(DialogContent, { sx: { m: 4 }, children: _jsx(DialogContent, { children: _jsx(AddBpayBiller, { handleClose: handleClose }) }) }) })] }));
};
const ManageBPayBillerHistory = () => {
    const [billerToDelete, setBillerToDelete] = useState(undefined);
    const [deleteBPayMutation, { loading: deleteBpayLoading }] = useDeleteBpayPartyBillerMutation();
    const fullScreen = useMediaQuery("(max-width: 768px)");
    const deleteBPay = () => {
        if (billerToDelete != null) {
            deleteBPayMutation({
                variables: {
                    input: { PartyBillerHistoryId: billerToDelete.id },
                },
                refetchQueries: [{ query: BpayBillerHistoryDocument }],
            }).then(() => setBillerToDelete(undefined));
        }
    };
    const { data, loading, error } = useBpayBillerHistoryQuery();
    if (loading) {
        return _jsx(Loading, {});
    }
    if (error != null || data?.userSession?.Party?.BpayBillerHistory == null) {
        return _jsx(CError, { error: "Could not retrieve BPAY Biller History" });
    }
    if (billerToDelete == null) {
        const bpayHistory = data.userSession.Party.BpayBillerHistory.map((x) => {
            return {
                code: x?.Billercode,
                id: x?.Id || "",
                description: x?.BillerDescription || "",
                customerReferenceNumber: x?.CustomerReferenceNumber || "",
                name: x?.BillerName || "",
                HasPendingTransfer: x?.HasPendingTransfer || false,
            };
        });
        return (_jsx(ManageBpayBillerHistoryView, { billerHistory: bpayHistory, deleteBiller: setBillerToDelete }));
    }
    return (_jsxs(Dialog, { fullScreen: fullScreen, className: "delete-payment-account", open: true, children: [_jsxs(DialogTitle, { children: [_jsx(DeleteIcon, {}), _jsx(Typography, { variant: "h5", gutterBottom: true, component: "h5", sx: { mx: 2, mb: 2 }, children: "Delete Biller?" })] }), _jsx(DialogContent, { sx: { m: 4, mt: 0 }, children: _jsxs(DialogContentText, { children: [_jsxs(Typography, { variant: "body1", gutterBottom: true, component: "p", sx: { textAlign: "center" }, children: ["Are you sure you would like to delete this ", _jsx(BpayText, {}), " ", "biller?"] }), _jsxs(List, { sx: { mb: 2 }, children: [_jsx(ListItem, { disablePadding: true, children: _jsx(ListItemText, { primary: _jsx(Typography, { children: _jsx("span", { className: "subtitle", children: billerDisplayName(billerToDelete) }) }) }) }), _jsx(ListItem, { disablePadding: true, children: _jsx(ListItemText, { primary: _jsxs(Typography, { children: [_jsxs("span", { className: "subtitle", children: ["Biller Code:", " "] }), " ", billerToDelete.code] }) }) }), _jsx(ListItem, { disablePadding: true, children: _jsx(ListItemText, { primary: _jsxs(Typography, { children: [_jsxs("span", { className: "subtitle", children: ["Customer Ref:", " "] }), " ", billerToDelete.customerReferenceNumber] }) }) })] }), billerToDelete.HasPendingTransfer === true && (_jsx(Alert, { severity: "warning", children: "There are Upcoming Transfers against these details. They will continue to be processed as usual unless cancelled manually." })), _jsxs("div", { className: "button-row", children: [_jsx(Button, { className: "btn-cancel", id: "cancel", sx: { p: 1.5, mt: 1 }, variant: "contained", onClick: () => setBillerToDelete(undefined), children: "Cancel" }), _jsx(LoadingButton, { type: "submit", id: "submit", sx: { p: 1.5, mt: 1 }, onClick: () => deleteBPay(), loading: deleteBpayLoading, loadingPosition: "end", variant: "contained", children: "Confirm" })] })] }) })] }));
};
export default ManageBPayBillerHistory;
